var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "charts" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c("tile-tabs", { attrs: { tabsCount: 3 } }, [
          _c(
            "button",
            {
              attrs: { slot: "slot1" },
              on: {
                click: function ($event) {
                  return _vm.changeChart("count")
                },
              },
              slot: "slot1",
            },
            [_vm._v("Количество, шт.")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { slot: "slot2" },
              on: {
                click: function ($event) {
                  return _vm.changeChart("sum")
                },
              },
              slot: "slot2",
            },
            [_vm._v("Сумма, млн. "), _c("i", { staticClass: "uk-icon-rub" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { slot: "slot3" },
              on: {
                click: function ($event) {
                  return _vm.changeChart("products")
                },
              },
              slot: "slot3",
            },
            [_vm._v("Виды услуг/продукции, %")]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "chart-container" },
      [
        _c("chart", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentChart === "count",
              expression: "currentChart === 'count'",
            },
          ],
          attrs: {
            type: "bar",
            data: _vm.countChartData,
            options: _vm.barOptions,
          },
        }),
        _vm._v(" "),
        _c("chart", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentChart === "sum",
              expression: "currentChart === 'sum'",
            },
          ],
          attrs: {
            type: "bar",
            data: _vm.sumChartData,
            options: _vm.barOptions,
          },
        }),
        _vm._v(" "),
        _c("chart", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentChart === "products",
              expression: "currentChart === 'products'",
            },
          ],
          attrs: {
            type: "pie",
            data: _vm.productsChartData,
            options: _vm.pieOptions,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }